import { ArdoqId, GraphSearchRunResponse } from '@ardoq/api-types';
import { Method, fetchBlob, fetchJson, headers, toRequestOptions } from './api';
import { ApiResponse } from './types';

const MAX_GREMLIN_RESULTS_RETURNED = 100000;
const allResults = { size: MAX_GREMLIN_RESULTS_RETURNED };

type GraphSearchRequest = {
  query: string;
  queryParams?: Record<string, any>;
};

const graphSearchExport = async ({
  query,
  queryParams,
}: GraphSearchRequest): ApiResponse<Blob> => {
  const request = new Request(
    '/api/graph-search-export',
    toRequestOptions(Method.POST, { query, queryParams })
  );
  return fetchBlob(request);
};

const graphSearch = <T>({
  query,
  queryParams,
}: GraphSearchRequest): ApiResponse<GraphSearchRunResponse<T>> => {
  const request = new Request(
    '/api/graph-search',
    toRequestOptions(Method.POST, { query, queryParams })
  );
  return fetchJson<GraphSearchRunResponse<T>>(request);
};

const parameterizedGraphSearch = <T>(
  parameterQueryId: ArdoqId,
  options?: {
    size?: number;
    componentProps?: string;
  }
): ApiResponse<GraphSearchRunResponse<T>> => {
  const url = new URL(
    `/api/graph-search/${parameterQueryId}/run`,
    window.location.origin
  );
  if (options?.size) {
    url.searchParams.append('size', options.size.toString());
  }
  if (options?.componentProps) {
    url.searchParams.append('componentProps', options.componentProps);
  }
  const request = new Request(url, {
    headers,
  });
  return fetchJson<GraphSearchRunResponse<T>>(request);
};

export const graphSearchApi = {
  graphSearchExport,
  allResults,
  graphSearch,
  parameterizedGraphSearch,
};
